import { DotV2 } from 'common/pill-v2/dot-v2.js';
import { PillDynamicWrapperV2 } from 'common/pill-v2/pill-dynamic-wrapper-v2.js';
import { PillPointer } from 'common/pill-v2/pill-pointer.js';
import { PillV2Label } from 'common/pill-v2/pill-v2-label.js';
import { MarkerV2SecondaryData } from 'common/pill-v2/pill-v2-secondary-data.js';
import { PillV2 } from 'common/pill-v2/pill-v2.js';
import { onClickStaticMapType } from 'components/map/map-controller/main/leaflet-click/click-updateSlot.js';
import { getMarkerV2ThemedPill, MarkerOptionsMap } from 'components/map/themes/pill-theme.js';
import { MarkerDisplaySize, RadioFilterTypes } from 'types/location.js';
import { MarkerPillFilterPoint } from 'types/markerTypesV2/m-v2-core.js';
import { IMarkerV2 } from 'types/markerTypesV2/m-v2-general.js';
import { predicatePopulatedString } from 'utilities/isType';
import { getMarkerV2TextPos } from './marker-v2';

const getFinalView = ({
  marker,
  stationType,
}: {
  marker: IMarkerV2<MarkerPillFilterPoint>;
  stationType?: RadioFilterTypes;
}) => {
  const { view, views } = marker;
  if (views && stationType) {
    const finalView = views[stationType];
    return { ...view, ...finalView };
  }
  return null;
};

export const mergeMarkerTags = ({ theme, tags = [] }: { theme?: string; tags?: string[] }) => {
  if (predicatePopulatedString(theme)) {
    return [theme, ...tags];
  }
  return tags;
};

export const MarkerFilterPillV2 = ({
  markerDisplaySize,
  marker,
  selected,
  mockHover,
  markerThemes,
  onClick,
  stationType,
}: {
  marker: IMarkerV2<MarkerPillFilterPoint>;
  markerDisplaySize: MarkerDisplaySize;
  selected?: boolean;
  mockHover?: boolean;
  markerThemes?: MarkerOptionsMap;
  onClick?: onClickStaticMapType;
  stationType?: RadioFilterTypes;
}) => {
  const { position, label } = marker;
  const view = getFinalView({ marker, stationType });
  if (view?.icon || view?.text || view?.theme) {
    const themeProps = getMarkerV2ThemedPill({
      tags: mergeMarkerTags({ theme: view?.theme, tags: marker?.tags }),
      meta: view?.meta ?? view?.status ?? view?.text,
      icon: view?.icon,
      markerThemes,
      defaultTheme: { border: '#ffffff', background: '#ffffff', text: '#0B1940' },
    });
    const isDot = markerDisplaySize === MarkerDisplaySize.Small;
    const textPos = getMarkerV2TextPos(marker);

    return (
      <PillDynamicWrapperV2
        displaySize={markerDisplaySize}
        selected={selected}
        mockHover={mockHover}
        staticPosition={position.staticPoint}
        labelPos={position.labelPos}
        markerType={marker.type}
        hasPoint={view?.hasPoint}
        offset={position.offset}
        isDot={isDot}
        onClick={onClick}
        textPos={textPos}
      >
        {isDot ? (
          <DotV2 themeProps={themeProps} />
        ) : (
          <>
            <PillV2
              icons={[view?.icon ?? themeProps?.icon]}
              className={`pill--border u-posRel ${marker.view?.pillClass ?? ''}`}
              label={view?.text}
              themeProps={themeProps}
            />
            <PillPointer
              border={themeProps?.border}
              labelPos={position.labelPos}
              hasPoint={view?.hasPoint}
              id={view?.text}
            />
            <PillV2Label
              selected={selected}
              label={label?.text ?? ''}
              displaySize={markerDisplaySize}
              mockHover={mockHover}
              textPos={textPos}
            >
              <MarkerV2SecondaryData secondaryData={label?.suffix} warningsList={marker.generatedWarningsList} />
            </PillV2Label>
          </>
        )}
      </PillDynamicWrapperV2>
    );
  }
};
